var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('partica-error',{attrs:{"errorinfo":_vm.errorinfo,"showerror":_vm.showerror},on:{"close":function($event){return _vm.CloseErrorDialog()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }